export default "__VITE_ASSET__cqhN4cn$__"